export const STORAGEKEY = "collective.bookmarks";
